import { FormattedMessage, injectIntl } from "react-intl";

import { Formik } from "formik";
import { isEmpty } from "lodash-es";
import isEmail from "validator/lib/isEmail";
import PermissionEdit from "./PermissionEdit";
import { createPermissionKey } from "../../utils/permissionUtils";
import { DeleteActionButton } from "../ActionBar";
import { Form, TextInput, SubmitButton } from "../Form";
// @ts-expect-error TS(2724) FIXME: '"../../shapes"' has no exported member named 'use... Remove this comment to see the full error message
import { usersPermissionsShape, intlShape } from "../../shapes";

type OwnProps = {
  allowedPermissions: $TSFixMe[]; // TODO: PropTypes.oneOf([ PermissionType.READ, PermissionType.UPDATE, PermissionType.DELETE, PermissionType.PERMIT, ])
  onPermissionCreate: $TSFixMeFunction;
  intl: intlShape;
  onPermissionDelete: $TSFixMeFunction;
  onDelete: $TSFixMeFunction;
  onAdd: $TSFixMeFunction;
  permitableId: number;
  permitableType: string;
  usersPermissions: usersPermissionsShape;
  currentUser: {
    id?: number;
  };
  acceptConnectUsers?: boolean;
};

const defaultProps: Partial<OwnProps> = {
  acceptConnectUsers: false,
};

type Props = OwnProps & typeof defaultProps;

function UserPermissionsEdit({
  permitableId,
  permitableType,
  onPermissionDelete,
  onDelete,
  onPermissionCreate,
  onAdd,
  intl,
  currentUser,
  usersPermissions,
  allowedPermissions,
  acceptConnectUsers,
}: Props) {
  const renderUserPermissions = (userPermissions: $TSFixMe) => {
    // user should not edit his own permissions via UI says the PO ;)
    const disabledByUser =
      currentUser !== null && userPermissions.id === currentUser.id;
    const renderedPermissionItems = allowedPermissions.map((permissionType) => {
      const key = createPermissionKey(
        permitableType,
        permitableId,
        "User",
        userPermissions.id,
        permissionType,
      );
      const permissionId = userPermissions[permissionType.substring(4)];
      return (
        <PermissionEdit
          key={key}
          onCreate={onPermissionCreate}
          onDelete={onPermissionDelete}
          permissionId={permissionId}
          assignableId={userPermissions.id}
          assignableType="User"
          permissionType={permissionType}
          permitableId={permitableId}
          // @ts-expect-error TS(2322) FIXME: Type '{ key: string; onCreate: $TSFixMeFunction; o... Remove this comment to see the full error message
          permitableType={permitableType}
          disabled={disabledByUser}
        />
      );
    });

    return (
      <div
        key={userPermissions.id}
        className="permission-group-item"
        id="permission-user-items"
      >
        <div className="permission-assignee">
          <div>{userPermissions.name}</div>
          <span className="permission-user-email">{userPermissions.email}</span>
        </div>
        <div className="permission-items" id="permission-user-item">
          {renderedPermissionItems}
          <div className="permission-delete">
            <DeleteActionButton
              disabled={disabledByUser}
              modalTitle={intl.formatMessage({
                id: "edit_permissions.delete.modal_title",
              })}
              modalMessage={intl.formatMessage(
                { id: "edit_permissions.delete.modal_message" },
                { name: userPermissions.name },
              )}
              onConfirm={() => onDelete(userPermissions.id, true)}
            />
          </div>
        </div>
      </div>
    );
  };

  const validConnectUser = (email: $TSFixMe) =>
    acceptConnectUsers && email.split("@")[1] === "connect";

  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (isEmpty(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.mandatory",
      });
    } else if (!isEmail(values.email) && !validConnectUser(values.email)) {
      (errors as $TSFixMe).email = intl.formatMessage({
        id: "validation.email.invalid",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    const userPermissionItems = usersPermissions.map(
      (userPermission: $TSFixMe) => renderUserPermissions(userPermission),
    );
    return (
      <div id="edit-user-permissions" className="permission-group-items">
        <h3>
          <FormattedMessage id="edit_permissions.users" />
        </h3>
        {userPermissionItems}
        <Form {...formProps}>
          <TextInput
            {...formProps}
            hideLabel
            id="user-email"
            label={intl.formatMessage({ id: "label.email" })}
            name="email"
          />
          <SubmitButton
            id="add-user-permissions"
            text={intl.formatMessage({
              id: "edit_permissions.add_user_button",
            })}
            fetching={isSubmitting}
          />
        </Form>
      </div>
    );
  };

  return (
    <Formik validate={validateForm} onSubmit={onAdd} initialValues={{}}>
      {renderForm}
    </Formik>
  );
}

UserPermissionsEdit.defaultProps = defaultProps;

export default injectIntl(UserPermissionsEdit);
